export default "__VITE_ASSET__DcNfGsxK__"